<template>
  <div id="journey">

    <video @timeupdate="videoTimeUpdate" id="video" playsinline muted preload="auto" class="video videoRatio"></video>
    <audio id="audio" loop muted preload="auto"></audio>


    

    <img class="video videoRatio" v-show="this.isShowFirstFrame" :src="this.firstFrame" 
                                          @mousedown.prevent=""
                                          @mouseup.prevent=""
                                          @touchstart.prevent=""
                                          @touchmove.prevent=""
                                          @touchend.prevent="">

    <transition name="fade">
      <img class="journeyMainText" v-show="this.isShowJourneyMainText" :src="this.journeyMainTextTC" v-if="this.language == 'TC'">
      <img class="journeyMainText" v-show="this.isShowJourneyMainText" :src="this.journeyMainTextEN" v-if="this.language == 'EN'">
    </transition>

    <transition name="fade">
      <img class="scrollToStartTC" v-show="this.isShowScrollToStart" src="~@/../src/assets/images/journey/scrollToStartTC.png" v-if="this.language == 'TC'">
      <img class="scrollToStartEN" v-show="this.isShowScrollToStart" src="~@/../src/assets/images/journey/scrollToStartEN.png" v-if="this.language == 'EN'">
    </transition>

    <div class="scrollToStartAnimation" v-show="this.isShowScrollToStart">
      <div class="snippet">
        <div class="stage">
          <div class="dotFlashing dotFlashing1"></div>
          <div class="dotFlashing dotFlashing2"></div>
          <div class="dotFlashing dotFlashing3"></div>
        </div>
      </div>
    </div>


    
    <div class="scrollToStartArea touch"  v-show="this.isShowScrollToStart"
                                          @mousedown.prevent="scrollToStartMouseDown"
                                          @mouseup.prevent="scrollToStartMouseUp"
                                          @touchstart.prevent="scrollToStartTouchDown"
                                          @touchmove.prevent="scrollToStartTouchMove"
                                          @touchend.prevent="scrollToStartTouchUp"></div>
    <div class="scrollToStartArea touch" v-show="!this.isShowScrollToStart && !this.isAndroidFirefox"
                                          @mousedown.prevent=""
                                          @mouseup.prevent=""
                                          @touchstart.prevent=""
                                          @touchmove.prevent=""
                                          @touchend.prevent=""></div>
    <transition name="fade">
      <div class="checkpointArea" v-show="this.isShowCheckpoint1">
        <img class="checkpoint" src="~@/../src/assets/images/journey/checkpoint1TC.png" v-if="this.language == 'TC'">
        <img class="continueTC touch" src="~@/../src/assets/images/journey/continueTC.png" v-if="this.language == 'TC'" @mouseup.prevent="finishCheckpoint1">
        <img class="checkpoint" src="~@/../src/assets/images/journey/checkpoint1EN.png" v-if="this.language == 'EN'">
        <img class="continueEN touch" src="~@/../src/assets/images/journey/continueEN.png" v-if="this.language == 'EN'" @mouseup.prevent="finishCheckpoint1">
      </div>
    </transition>
    <transition name="fade">
      <div class="checkpointArea" v-show="this.isShowCheckpoint2">
        <img class="checkpoint" src="~@/../src/assets/images/journey/checkpoint2TC.png" v-if="this.language == 'TC'">
        <img class="continueTC touch" src="~@/../src/assets/images/journey/continueTC.png" v-if="this.language == 'TC'" @mouseup.prevent="finishCheckpoint2">
        <img class="checkpoint" src="~@/../src/assets/images/journey/checkpoint2EN.png" v-if="this.language == 'EN'">
        <img class="continueEN touch" src="~@/../src/assets/images/journey/continueEN.png" v-if="this.language == 'EN'" @mouseup.prevent="finishCheckpoint2">
      </div>
    </transition>

    <transition name="fade">
      <div class="checkpointArea" v-show="this.isShowCheckpoint3">
        <img class="checkpoint" src="~@/../src/assets/images/journey/checkpoint3TC.png" v-if="this.language == 'TC'">
        <img class="continueTC touch" src="~@/../src/assets/images/journey/continueTC.png" v-if="this.language == 'TC'" @mouseup.prevent="finishCheckpoint3">
        <img class="checkpoint" src="~@/../src/assets/images/journey/checkpoint3EN.png" v-if="this.language == 'EN'">
        <img class="continueEN touch" src="~@/../src/assets/images/journey/continueEN.png" v-if="this.language == 'EN'" @mouseup.prevent="finishCheckpoint3">
      </div>
    </transition>

    <transition name="fade">
      <div class="checkpointArea" v-show="this.isShowCheckpoint4">
        <img class="checkpoint" src="~@/../src/assets/images/journey/checkpoint4TC.png" v-if="this.language == 'TC'">
        <img class="continueTC touch" src="~@/../src/assets/images/journey/continueTC.png" v-if="this.language == 'TC'" @mouseup.prevent="finishCheckpoint4">
        <img class="checkpoint" src="~@/../src/assets/images/journey/checkpoint4EN.png" v-if="this.language == 'EN'">
        <img class="continueEN touch" src="~@/../src/assets/images/journey/continueEN.png" v-if="this.language == 'EN'" @mouseup.prevent="finishCheckpoint4">
      </div>
    </transition>

    <transition name="fade">
      <img v-show="this.isShowDisneyC" class="disneyC" src="~@/../src/assets/images/journey/disneyC.png">
    </transition>
    <transition name="fade">
      <img v-show="this.isShowDisneyC" class="remarkTC" src="~@/../src/assets/images/journey/remarkTC.png" v-if="this.language == 'TC'">
      <img v-show="this.isShowDisneyC" class="remarkEN" src="~@/../src/assets/images/journey/remarkEN.png" v-if="this.language == 'EN'">
    </transition>
    

    <img class="disneyLogo" :src="this.logo"/>
  </div>
</template>

<script>

import i18n from '@/language';
import { store } from '../store'
import base64FirstFrame from '@/assets/images/base64/firstFrame.js';
import base64JourneyMainTextTC from '@/assets/images/base64/journeyMainTextTC.js';
import base64JourneyMainTextEN from '@/assets/images/base64/journeyMainTextEN.js';
import base64Logo from '@/assets/images/base64/logo.js';
import * as commonFunction from '@/commonFunction/commonFunction'

export default {
  name: 'journey',
  components: {
    
  },
  data () {
    return {
      language : i18n.locale,
      videoElement : null,
      audioElement : null,
      checkVideoLoadedInterval : null,
      scrollToStartY : 0,
      scrollToStartTouchY : 0,
      isShowJourneyMainText : true,
      isShowScrollToStart : true,
      isShowFirstFrame : true,
      isShowCheckpoint1 : false,
      isShowCheckpoint2 : false,
      isShowCheckpoint3 : false,
      isShowCheckpoint4 : false,
      isShowDisneyC : false,
      isAndroidFirefox : false,
      // isShowSubTitle1 : false,
      // isShowSubTitle2 : false,
      // isShowSubTitle3 : false,
      // isShowSubTitle4 : false,
      videoProgress : 0,
      checkPoint: 0,
      firstFrame : base64FirstFrame.data,
      journeyMainTextTC : base64JourneyMainTextTC.data,
      journeyMainTextEN : base64JourneyMainTextEN.data,
      logo : base64Logo.data
    }
  },
  created(){
    //~@/../src/assets/videos/journey.mp4
    this.loadVideo();
    this.loadAudio();
    if(commonFunction.isIOSwithChrome()){
      setTimeout(function(){
        var style = document.getElementById("journey").getAttribute("style");
        if(style != null){
          var addStyle = style + "height:" + window.innerHeight + "px;";
        }
        else{
          var addStyle = "height:" + window.innerHeight + "px;";
        }
        document.getElementById("journey").setAttribute("style",addStyle);
      },200)
    }
  },
  methods:{
    loadVideo(){
      var self = this;
      var xhr = new XMLHttpRequest();
      xhr.responseType = 'blob';
      xhr.onload = function() {
        var reader = new FileReader();
        reader.onloadend = function() {
          var byteCharacters = atob(reader.result.slice(reader.result.indexOf(',') + 1));
          var byteNumbers = new Array(byteCharacters.length);
          for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          var byteArray = new Uint8Array(byteNumbers);
          var blob = new Blob([byteArray], {type: 'video/mp4'});
          var url = URL.createObjectURL(blob);
          
          //document.getElementById('_video').src = url;
          self.videoElement = document.getElementById("video");
          self.videoElement.src = url;
          // self.videoElement.play();
          // setTimeout(function(){
          //   self.videoElement.pause();
          // },2000);
          if(commonFunction.isAndroidFirefox()){
            self.isAndroidFirefox = true;
            store.state.isLoadVideoFinish = true;
          }else{
            store.state.isShowLoadingScreen = false;
            store.state.isShowJourney = true;
            store.state.isShowMainMenuButton = true;
          }
          
          var timeSincePageLoad = Math.round(performance.now());
          gtag('event', 'Video Download Finish', {
            'name': 'Download Video Time',
            'value': timeSincePageLoad,
            'send_to': 'G-LPYZD9LDDW'
          });
          gtag('event', 'page_view', { 
            'page_title': 'Video Page',
            'send_to': 'G-LPYZD9LDDW'
          });

        }
        reader.readAsDataURL(xhr.response);
      };
      xhr.open('GET', 'static/videos/journey.mp4');
      xhr.send();
    },


    loadAudio(){
      var self = this;
      var xhr = new XMLHttpRequest();
      xhr.responseType = 'blob';
      xhr.onload = function() {
        var reader = new FileReader();
        reader.onloadend = function() {
          var byteCharacters = atob(reader.result.slice(reader.result.indexOf(',') + 1));
          var byteNumbers = new Array(byteCharacters.length);
          for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          var byteArray = new Uint8Array(byteNumbers);
          var blob = new Blob([byteArray], {type: 'audio/mpeg'});
          var url = URL.createObjectURL(blob);
          
          //document.getElementById('_video').src = url;
          self.audioElement = document.getElementById("audio");
          self.audioElement.src = url;
          store.audioElement = self.audioElement;

        }
        reader.readAsDataURL(xhr.response);
      };
      xhr.open('GET', 'static/audios/bgm.mp3');
      xhr.send();
    },

    scrollToStartMouseDown(event){
      this.scrollDownY = event.clientY;
    },
    scrollToStartMouseUp(event){
      if(this.scrollDownY - event.clientY > 50){
        this.playVideo();
        gtag('event', 'Swipe Up To Play',{
          'send_to': 'G-LPYZD9LDDW'
        });
      }
    },
    scrollToStartTouchDown(event){
      this.scrollDownY = event.touches[0].clientY;
      if(!store.state.isMuted){
        this.audioElement.muted = false;
      }
      this.videoElement.muted = false;
    },

    scrollToStartTouchMove(event){
      this.scrollDownTouchY = event.touches[0].clientY;
    },

    scrollToStartTouchUp(){
      if(this.scrollDownY - this.scrollDownTouchY > 50 && this.scrollDownTouchY != 0){
        this.audioElement.play();
        this.playVideo();
        gtag('event', 'Swipe Up To Play',{
          'send_to': 'G-LPYZD9LDDW'
        });
      }
    },

    videoTimeUpdate(event){
      var self = this;
      var currentPercentage = this.videoElement.currentTime/this.videoElement.duration;
      if(!this.isShowCheckpoint1 && (this.videoElement.currentTime > 6.0 && this.checkPoint == 0) ){
        self.checkpoint1();
        this.checkPoint = 1;
        gtag('event', 'Check Point 1',{
          'send_to': 'G-LPYZD9LDDW'
        });
        gtag('event', 'conversion', {
          'allow_custom_scripts': true,
          'send_to': 'DC-8227103/15tha0/pi_hk005+standard'
        });
        
      }else if(!this.isShowCheckpoint2 && (this.videoElement.currentTime > 12.0) && this.checkPoint == 1){
        self.checkpoint2();
        this.checkPoint = 2;
        gtag('event', 'Check Point 2',{
          'send_to': 'G-LPYZD9LDDW'
        });
        gtag('event', 'conversion', {
          'allow_custom_scripts': true,
          'send_to': 'DC-8227103/15tha0/pi_hk005+standard'
        });
      }else if(!this.isShowCheckpoint3 && (this.videoElement.currentTime > 17.0) && this.checkPoint == 2){
        self.checkpoint3();
        this.checkPoint = 3;
        gtag('event', 'Check Point 3',{
          'send_to': 'G-LPYZD9LDDW'
        });
        gtag('event', 'conversion', {
          'allow_custom_scripts': true,
          'send_to': 'DC-8227103/15tha0/pi_hk005+standard'
        });
      }else if(!this.isShowCheckpoint4 && (this.videoElement.currentTime > 22.0) && this.checkPoint == 3){
        self.checkpoint4();
        this.checkPoint = 4;
        gtag('event', 'Check Point 4',{
          'send_to': 'G-LPYZD9LDDW'
        });
        gtag('event', 'conversion', {
          'allow_custom_scripts': true,
          'send_to': 'DC-8227103/15tha0/pi_hk005+standard'
        });
      }else if(!this.isShowCheckpoint4 && (this.videoElement.currentTime > 30.0) && this.checkPoint == 4){
        this.checkPoint = 5;
        self.finishJourney();
      }


      if(currentPercentage >= 0.1 && currentPercentage <0.2 && this.videoProgress < 0.1){
        gtag('event', 'Video 10% progress',{
          'send_to': 'G-LPYZD9LDDW'
        });
        this.videoProgress = 0.1;
      }else if(currentPercentage >= 0.2 && currentPercentage < 0.3 && this.videoProgress < 0.2){
        gtag('event', 'Video 20% progress',{
          'send_to': 'G-LPYZD9LDDW'
        });
        this.videoProgress = 0.2;
      }else if(currentPercentage >= 0.3 && currentPercentage < 0.4 && this.videoProgress < 0.3){
        gtag('event', 'Video 30% progress',{
          'send_to': 'G-LPYZD9LDDW'
        });
        this.videoProgress = 0.3;
      }else if(currentPercentage >= 0.4 && currentPercentage < 0.5 && this.videoProgress < 0.4){
        gtag('event', 'Video 40% progress',{
          'send_to': 'G-LPYZD9LDDW'
        });
        this.videoProgress = 0.4;
      }else if(currentPercentage >= 0.5 && currentPercentage < 0.6 && this.videoProgress < 0.5){
        gtag('event', 'Video 50% progress',{
          'send_to': 'G-LPYZD9LDDW'
        });
        this.videoProgress = 0.5;
      }else if(currentPercentage >= 0.6 && currentPercentage < 0.7 && this.videoProgress < 0.6){
        gtag('event', 'Video 60% progress',{
          'send_to': 'G-LPYZD9LDDW'
        });
        this.videoProgress = 0.6;
      }else if(currentPercentage >= 0.7 && currentPercentage < 0.8 && this.videoProgress < 0.7){
        gtag('event', 'Video 70% progress',{
          'send_to': 'G-LPYZD9LDDW'
        });
        this.videoProgress = 0.7;
      }else if(currentPercentage >= 0.8 && currentPercentage < 0.9 && this.videoProgress < 0.8){
        gtag('event', 'Video 80% progress',{
          'send_to': 'G-LPYZD9LDDW'
        });
        this.videoProgress = 0.8;
      }else if(currentPercentage >= 0.9 && currentPercentage < 1.0 && this.videoProgress < 0.9){
        gtag('event', 'Video 90% progress',{
          'send_to': 'G-LPYZD9LDDW'
        });
        this.videoProgress = 0.9;
      }else if(currentPercentage >= 1.0 && this.videoProgress < 1.0){
        gtag('event', 'Video 100% progress',{
          'send_to': 'G-LPYZD9LDDW'
        });
        this.videoProgress = 1.0;
      }
    },

    playVideo(){
      var self = this;
      this.videoElement.currentTime = 0;
      this.videoElement.play();
      this.isShowDisneyC = true;
      setTimeout(function(){
        self.isShowDisneyC = false;
      }, 7000);

      // setTimeout(function(){
      //   self.checkpoint1();
      // }, 8000);

      setTimeout(function(){
        self.isShowScrollToStart = false;
        self.isShowJourneyMainText = false;
        self.isShowFirstFrame = false;
      }, 200);
    },

    checkpoint1(){
      this.isShowCheckpoint1 = true;
      this.videoElement.pause();
    },

    finishCheckpoint1(){
      var self = this;
      this.isShowCheckpoint1 = false;
      this.videoElement.play();
      // setTimeout(function(){
      //   self.checkpoint2();
      // }, 6000);
    },

    checkpoint2(){
      this.isShowCheckpoint2 = true;
      this.videoElement.pause();
    },

    finishCheckpoint2(){
      var self = this;
      this.isShowCheckpoint2 = false;
      this.videoElement.play();
      // setTimeout(function(){
      //   self.checkpoint3();
      // }, 4000);
    },

    checkpoint3(){
      this.isShowCheckpoint3 = true;
      this.videoElement.pause();
    },

    finishCheckpoint3(){
      var self = this;
      this.isShowCheckpoint3 = false;
      this.videoElement.play();
      // setTimeout(function(){
      //   self.checkpoint4();
      // }, 6000);
    },

    checkpoint4(){
      this.isShowCheckpoint4 = true;
      this.videoElement.pause();
    },

    finishCheckpoint4(){
      var self = this;
      this.isShowCheckpoint4 = false;
      this.videoElement.play();
      // setTimeout(function(){
      //   self.finishJourney();
      // }, 6000);
    },

    finishJourney(){
      var timeStampInMs = window.performance && window.performance.now && window.performance.timing && window.performance.timing.navigationStart ? window.performance.now() + window.performance.timing.navigationStart : Date.now();

console.log(timeStampInMs, Date.now());
      
      var self = this;
      this.isShowSubTitle4 = false;
      store.state.isShowFinalScreen = true;
      setTimeout(function(){
        self.videoElement.currentTime = 0;
        self.videoElement.pause();
      }, 1000);
      gtag('event', 'page_view', { 
        'page_title': 'Invitation Page',
        'send_to': 'G-LPYZD9LDDW'
      });
    },

    replayJourney(){
      this.checkPoint = 0;
      this.videoProgress = 0;
      this.isShowScrollToStart = true;
      this.isShowJourneyMainText = true;
      this.isShowFirstFrame = true;
    },


  },

  computed:{
    checkCurrentLanguage(){return i18n.locale;},
    checkReplayJourneyEvent(){return store.state.replayJourneyEvent},
  },
  watch:{
    checkCurrentLanguage(lang){
      this.language = lang;
    },
    checkReplayJourneyEvent(replayJourneyEvent){
      if(replayJourneyEvent){
        this.replayJourney();
        store.state.replayJourneyEvent = false;
      }
    },
  },
}
</script>

<style scoped>
  .disneyLogo{
    position: absolute;
    top: 24px;
    left: 50%;
    transform: translate3d(-50%,0,0);
    width: 120px;
    height: auto;
  }
  #journey{
    position: fixed;
    top: 0%;
    left: 0%;
    width: 100%;
    height: calc(100% + 5px);
    overflow: hidden;
  }

  .journeyMainText{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%,-50%,0);
    width: 250px;
    max-width: 70%;
  }

  .scrollToStartTC{
    position: absolute;
    left: 50%;
    top: 100%;
/*    bottom: 50px;*/
    width: 100px;
    max-width: 30%;
    transform: translate3d(-50%,calc(-100% - 50px),0);
  }

  .scrollToStartEN{
    position: absolute;
    left: 50%;
    top: 98%;
/*    bottom: 50px;*/
    width: 100%;
    max-width: 55%;
    transform: translate3d(-50%,calc(-100% - 50px),0);
  }

  .scrollToStartAnimation{
    position: absolute;
    left: 50%;
    top: 100%;
    width: 100px;
    max-width: 30%;
    transform: translate3d(-50%,calc(-100% - 20px),0)rotate(180deg);
  }

  .video{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%,-50%,0);
  }

  @media (max-aspect-ratio: 1080 / 1080){.videoRatio{min-height: 100%;  min-width: 100%;max-height: 100%}}
  @media (min-aspect-ratio: 1080 / 1080){.videoRatio{min-width: 100%;min-height: 100%}}

  .scrollToStartArea{
    position: absolute;
    top:0%;
    left: 0%;
    width: 100%;
    height: 100%;
  }


  .subtitle{
    position: absolute;
    width: 100vh;
    top: 100%;
    left: 50%;
    transform: translate3d(-50%,-100%,0);
  }

  .checkpointArea{
    position: absolute;
    left: 50%;
    transform: translate3d(-50%,0,0);
    bottom: 5vw;
    width: 95%;
  }

  .checkpoint{
    position: relative;
    left: 50%;
    transform: translate3d(-50%,0,0);
    width: 100%;
  }

  .continueTC{
    position: absolute;
    bottom: -2vw;
    left: 50%;
    transform: translate3d(-50%,0,0);
    width: 40%;
  }

  .continueEN{
    position: absolute;
    bottom: -2vw;
    left: 50%;
    transform: translate3d(-50%,0,0);
    width: 50%;
  }

  .disneyC{
    position: absolute;
    bottom: 2vw;
    right: 2vw;
    width: 50px;
    max-width: 15%;
  }

  .remarkEN{
    position: absolute;
    bottom: 2vw;
    left: 2vw;
    height: 2%;
  }

  .remarkTC{
    position: absolute;
    bottom: 2.5vw;
    left: 2vw;
    height: 2%;
  }

  .dotFlashing{
    position: relative;
    left: 50%;
    transform: translate3d(calc(-50% - 3px ),0,0);
    width: 12px;
    height: 12px;
    border-radius: 8px;
    background-color: #ffffff;
    color: #ffffff;
    margin-top: -3px;
  }

  .dotFlashing1 {
    animation: dotFlashing 1s infinite linear alternate;
    animation-delay: 0s;
  }

  .dotFlashing2 {
    animation: dotFlashing 1s infinite linear alternate;
    animation-delay: 0.25s;
  }
  .dotFlashing3 {
    animation: dotFlashing 1s infinite linear alternate;
    animation-delay: 0.5s;
  }

@keyframes dotFlashing {
  0% {
    background-color: rgba(200,200,200,1);
  }
  50%{
    background-color: rgba(200,200,200,0);
  }
  100% {
    background-color: rgba(200,200,200,0);
  }
  /*0% {
    background-color: rgba(200,200,200,0);
  }
  25% {
    background-color: rgba(200,200,200,1);
  }
  50% {
    background-color: rgba(200,200,200,0);
  }
  100% {
    background-color: rgba(200,200,200,0);
  }*/
}

</style>



// WEBPACK FOOTER //
// src/components/journey.vue